export const CATEGORIES = ['moon', 'galaxies', 'planets'];
export const PACE = ['easy', 'medium', 'hard', 'pro'];
export const INITIAL_CARDS_COUNT = 8;
